module.exports = __webpack_public_path__ + "b8e833f6a9ab70d02980eb6a35696561.svg";